function parseProductDetailQueryParams(queryParams) {
    const { isInsuranceReimbursable , offerings =''  } = queryParams || {};
    return {
        isReimbursable: isInsuranceReimbursable === 'true',
        filteredOfferings: Array.isArray(offerings) ? offerings : offerings.split(',').filter(Boolean)
    };
}

export { parseProductDetailQueryParams };
//# sourceMappingURL=parse-product-detail-query-params.js.map
